'use client';

import CustomLink from 'components/shared/CustomLink';
import { SplineViewer } from 'components/shared/SplineViewer/SplineViewer';
import {
  powerplugsDesktopSrc,
  powerplugsMobileSrc,
} from 'components/shared/SplineViewer/scenes';
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { useModal } from 'components/shared/Modal';
import { H1, P } from './styleConstants';
import styles from './HeroSection.module.css';
import { isMobileDevice } from 'utils/isMobile';
import { UhAppModal } from 'components/shared/UHAppDownloadModal';
import { useTranslations } from 'next-intl';

export const Powerplugs_HeroSection = ({
  className,
}: {
  className?: string;
}) => {
  const t = useTranslations('powerplugs');
  const searchParams = useSearchParams();
  const routerQuery = useMemo(() => {
    const query: Record<string, string | string[]> = {};
    if (!searchParams) return query;
    for (const key of searchParams.keys()) {
      const values = searchParams.getAll(key);
      query[key] = values.length > 1 ? values : values[0];
    }
    return query;
  }, [searchParams]);

  const ModalClient = useModal();

  const handleUHAppClick = () => {
    if (isMobileDevice()) {
      window.open('https://ultrahuman.onelink.me/QqSM/bsrsfmvk', '_blank');
    } else {
      ModalClient.set(
        <UhAppModal
          text={t('powerplugsPage.hero.appModal.text')}
          link="https://ultrahuman.onelink.me/QqSM/bsrsfmvk"
          image="web_v2/qr-codes/powerplugs-onelink.png"
        />,
      );
      ModalClient.show();
    }
  };

  return (
    <section className={[styles.root, className].filter(Boolean).join(' ')}>
      <div className={styles.canvasContainer}>
        <SplineViewer
          desktopSrc={powerplugsDesktopSrc}
          mobileSrc={powerplugsMobileSrc}
        />
      </div>

      <div className={styles.mainContent}>
        <p className={styles.caption}>{t('powerplugsPage.hero.introducing')}</p>
        <H1>{t('powerplugsPage.hero.brand')}</H1>
        <P>{t('powerplugsPage.hero.subtitle')}</P>
        <div className={styles.ctaContainer}>
          <CustomLink
            href={{
              pathname: '/blood-vision/tests',
              query: { ...routerQuery },
            }}
            className={styles.primary}
            onClick={(e) => {
              e.preventDefault();
              handleUHAppClick();
            }}
          >
            {t('powerplugsPage.hero.explore')}
          </CustomLink>
        </div>
      </div>
    </section>
  );
};
